"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _anatomogram = require("@ebi-gene-expression-group/anatomogram");

var _chartConfiguration = _interopRequireDefault(require("./chartConfiguration.js"));

var _heatmapData = _interopRequireDefault(require("./heatmapData.js"));

var _heatmapOrderings = _interopRequireDefault(require("./heatmapOrderings.js"));

var _heatmapColourAxis = _interopRequireDefault(require("./heatmapColourAxis.js"));

var _heatmapFilters = _interopRequireDefault(require("./heatmapFilters.js"));

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(_ref) {
  var data = _ref.data,
      inProxy = _ref.inProxy,
      outProxy = _ref.outProxy,
      atlasUrl = _ref.atlasUrl,
      showAnatomogram = _ref.showAnatomogram,
      showControlMenu = _ref.showControlMenu,
      isWidget = _ref.isWidget;
  var pathToResources = inProxy + (0, _urijs["default"])("resources/js-bundles/", atlasUrl).toString(); // This ensures that adding or removing coexpressed genes doesn’t change the colours in the heat map. Colours are
  // computed upfront and then we just add/remove rows with the coexpression slider.
  // coexpressions is an array because at first it was envisioned that the JSON payload could carry coexpressions of
  // more than one gene, but that’s not the case, and ended up being a single item array.

  var allRows = data.coexpressions ? data.profiles.rows.concat(data.coexpressions[0].jsonProfiles.rows) : data.profiles.rows;
  var heatmapData = (0, _heatmapData["default"])(Object.assign({}, data, {
    allRows: allRows,
    geneQuery: data.config.geneQuery,
    inProxy: inProxy,
    atlasUrl: atlasUrl,
    pathToResources: pathToResources
  })); //misses: idsExpressedInExperiment
  //show is extra

  var anatomogramConfig = {
    atlasUrl: atlasUrl,
    show: showAnatomogram && !!data.anatomogram && _anatomogram.anatomogramSpecies.includes(data.anatomogram.species),
    anatomogramData: data.anatomogram,
    expressedTissueColour: data.experiment ? "gray" : "red",
    hoveredTissueColour: data.experiment ? "red" : "purple"
  };
  var geneSpecificResults = data.experiment && data.experiment.urls && data.experiment.urls.gene_specific_results ? {
    url: inProxy + (0, _urijs["default"])(data.experiment.urls.gene_specific_results, atlasUrl).toString(),
    keepOnlyTheseColumnIds: data.columnHeaders.map(function (e) {
      return e.assayGroupId;
    }).filter(function (e, ix, self) {
      return self.indexOf(e) === ix;
    }).filter(function (e) {
      return e;
    })
  } : null;
  return {
    anatomogramConfig: anatomogramConfig,
    heatmapData: heatmapData,
    geneSpecificResults: geneSpecificResults,
    heatmapConfig: (0, _chartConfiguration["default"])(data, inProxy, outProxy, atlasUrl, isWidget, showControlMenu),
    colourAxis: (0, _heatmapColourAxis["default"])(data.experiment, heatmapData.dataSeries),
    orderings: (0, _heatmapOrderings["default"])(data.experiment, allRows, data.columnHeaders),
    columnGroups: (0, _heatmapFilters["default"])({
      heatmapData: heatmapData,
      columnGroupings: data.columnGroupings
    })
  };
}